import '../styles/page.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function Intro() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <section id="intro-banner">
        <div className="page-banner-bg">
          <div className="m-auto page-banner-container">
            <h2 data-aos="fade-right" data-aos-duration="700" data-aos-once="true">
              회사개요
            </h2>
            <p
              className="color-caption fs-md"
              data-aos="fade-right"
              data-aos-duration="700"
              data-aos-once="true"
              data-aos-delay="100"
            >
              TAKE를 소개합니다.
            </p>
          </div>
        </div>
      </section>

      <section id="intro-vision">
        <div
          className="intro-vision-container m-auto"
          data-aos="fade-up"
          data-aos-duration="700"
          data-aos-once="true"
          data-aos-delay="300"
        >
          <div className="center-title">
            <div className="line-hor"></div>
            <p className="fs-base fw-bold color-primary">VISION & MISSION</p>
            <h2 className="fw-bold mt- text-center">기술 너머의 가능성을 설계하다.</h2>
            <p className="text-center fs-md mt-8 color-caption">
              단순한 시스템을 넘어,
              <br className="pc-none" /> 고객 미래를 위한 도구를 설계하고 연결하는 기업.
              <br />
              <br className="pc-none" />
              우리는 기술을 '도구'가 아닌, '전략'으로 다루며
              <br className="pc-none" /> 산업과 사회를 변화시키는 여정을 함께합니다.
            </p>
            <p className="intro-vision-textmark fw-bold fs-lg">
              테이크는 기술 그 이상의
              <br className="pc-none" /> 가치를 만들어 갑니다.
            </p>
          </div>
          <ul className="intro-vision-content">
            <li>
              <img src="./images/ico-intro-vision01.svg" alt="" />
              <p className="fs-md color-primary fw-bold">접근성</p>
              <p className="text-center">
                누구나 쉽게 활용할 수 있는&nbsp;
                <br className="mo-none" />
                개발 환경을 통해
                <br />
                기술의 진입 장벽을 낮춥니다.
              </p>
            </li>
            <li>
              <img src="./images/ico-intro-vision02.svg" alt="" />
              <p className="fs-md color-primary fw-bold">유연성</p>
              <p className="text-center">
                기존 시스템을 최신화된 웹 기반으로&nbsp;
                <br className="mo-none" />
                전환하여
                <br className="pc-none" /> 유연하고 지속 가능한&nbsp;
                <br className="mo-none" />
                업무 환경을 만듭니다.
              </p>
            </li>
            <li>
              <img src="./images/ico-intro-vision03.svg" alt="" />
              <p className="fs-md color-primary fw-bold">확장성</p>
              <p className="text-center">
                UXBooster를 기반으로&nbsp;
                <br className="mo-none" />
                빠르고 안정적인
                <br />
                디지털 생태계를 구축합니다.
              </p>
            </li>
            <li>
              <img src="./images/ico-intro-vision04.svg" alt="" />
              <p className="fs-md color-primary fw-bold">신뢰성</p>
              <p className="text-center">
                고객의 과제를 함께 고민하며
                <br />
                실질적인 성과로 연결되는&nbsp;
                <br className="mo-none" />
                솔루션을 제공합니다.
              </p>
            </li>
          </ul>
        </div>
      </section>

      <section id="intro-business">
        <div className="intro-business-container m-auto">
          <div
            className="center-title"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-once="true"
          >
            <div className="line-hor"></div>
            <p className="fs-base fw-bold color-primary">BUSINESS</p>
            <h2 className="fw-bold text-center">
              모바일과 웹 기술의 장벽을 없애고,
              <br />
              가능성을 연결합니다.
            </h2>
          </div>
          <div
            className="intro-business-content"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="200"
          >
            <div className="intro-business-box intro-business-item">
              <div>
                <p className="color-primary fs-lg fw-bold mb-16">개발 프레임워크 사업</p>
                <p className="fw-bold fs-md">UXBooster 프레임워크 기반 개발 및 판매</p>
              </div>
              <div>
                <ul>
                  <li>
                    <p className="text-check fs-base">UXBooster</p>
                    <p className="fs-base color-caption text-check-caption">
                      시스템 개발 생산성을 높이는 혁신 프레임워크
                    </p>
                  </li>
                  <li>
                    <p className="text-check fs-base">UXBooster</p>
                    <p className="fs-base color-caption text-check-caption">
                      시스템 개발 생산성을 높이는 혁신 프레임워크
                    </p>
                  </li>
                  <li>
                    <p className="text-check fs-base">UXBooster</p>
                    <p className="fs-base color-caption text-check-caption">
                      시스템 개발 생산성을 높이는 혁신 프레임워크
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="intro-business-item">
              <div className="intro-business-box">
                <p className="color-primary fs-lg fw-bold mb-16">웹 전환 서비스</p>
                <p className="fs-md fw-bold mb-28">기존 C/S 시스템을 웹 기반으로 전환</p>
                <ul>
                  <li>
                    <p className="text-check fs-base">AIChanger</p>
                    <p className="text-check-caption fs-base color-caption">
                      AI기반의 자동 전환 및 최적화 기능 제공
                    </p>
                  </li>
                  <li>
                    <p className="text-check fs-base">시스템 통합 및 자동화 프로세스</p>
                  </li>
                </ul>
              </div>
              <div className="intro-business-box">
                <p className="color-primary fs-lg fw-bold mb-16">SI 서비스 및 컨설팅</p>
                <p className="fs-md fw-bold mb-28">기업 맞춤형 시스템 구축 및 컨설팅</p>
                <ul>
                  <li>
                    <p className="text-check fs-base">기업 내부 업무 시스템 개발</p>
                  </li>
                  <li>
                    <p className="text-check fs-base">생산, 구매, HR 등 다양한 업무 영역 개발</p>
                  </li>
                  <li>
                    <p className="text-check fs-base">
                      IT 역량이 부족한 고객도 쉽게 접근 가능한
                      <br />
                      "실행 중심 컨설팅"
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="intro-business-item">
              <div className="intro-business-box">
                <p className="color-primary fs-lg fw-bold mb-16">ESG 솔루션 (GEMS)</p>
                <p className="fs-md fw-bold mb-28">지속가능경영을 위한 ESG 중심 시스템</p>
                <ul>
                  <li>
                    <p className="text-check fs-base">GEMS</p>
                    <p className="text-check-caption fs-base color-caption">
                      기업 온실가스 배출량 측정 및 관리
                    </p>
                  </li>
                  <li>
                    <p className="text-check fs-base">ESG 경영 보고서 연계 가능</p>
                  </li>
                  <li>
                    <p className="text-check fs-base">정부 정책 및 국제 기준 대응 가능</p>
                  </li>
                </ul>
              </div>
              <div className="intro-business-box">
                <p className="color-primary fs-lg fw-bold mb-16">구매/입찰 솔루션 (EPRO)</p>
                <p className="fs-md fw-bold mb-28">기업간 전자구매 및 입찰관리 시스템</p>
                <ul>
                  <li>
                    <p className="text-check fs-base">EPRO</p>
                    <p className="text-check-caption fs-base color-caption">
                      협력사 관리, 입찰, 견적, 발주, 계약 등<br />
                      구매 업무 전 과정의 통합관리
                    </p>
                  </li>
                  <li>
                    <p className="text-check fs-base">
                      사용자 편의성과 안정성이 높은 구축형 솔루션
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="intro-history">
        <div className="intro-history-container m-auto">
          <div
            className="intro-history-title"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
          >
            <div className="left-title intro-history-sticky">
              <div className="line-hor"></div>
              <p className="fs-base fw-bold color-primary">HISTORY</p>
              <h2 className="fw-bold">
                테이크가 걸어온 길,
                <br />
                테이크가 앞으로 걸어갈 길
              </h2>
            </div>
          </div>
          <div
            className="intro-history-table"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
          >
            <div className="table-all">
              <div className="table-year">
                <p className="fs-lg table-year-dot">2025</p>
                <ul className="table-item fs-base">
                  <li>
                    <p className="month">06</p>
                    <p>벤처기업 재인증 획득</p>
                  </li>
                  <li>
                    <p className="month">04</p>
                    <p>국민대 가족회사 협약</p>
                  </li>
                  <li>
                    <p className="month">&ensp;</p>
                    <p>업무화면 자동화 및 AI 웹 전환 특허 2건 출원</p>
                  </li>
                  <li>
                    <p className="month">03</p>
                    <p>경기대 가족회사 협약</p>
                  </li>
                  <li>
                    <p className="month">&ensp;</p>
                    <p>경희대 산합협력 협약</p>
                  </li>
                  <li>
                    <p className="month">&ensp;</p>
                    <p>엠비즈플래닛 마케팅 협약</p>
                  </li>
                  <li>
                    <p className="month">02</p>
                    <p>한국중소기업발전협회 특허기반 R&D개발 협약</p>
                  </li>
                  <li>
                    <p className="month">01</p>
                    <p>중앙고속 차세대ERP 시스템 재구축</p>
                  </li>
                  <li>
                    <p className="month">&ensp;</p>
                    <p>영상공장 주식회사 업무협약</p>
                  </li>
                </ul>
              </div>
              <div className="table-year">
                <p className="fs-lg table-year-dot">2024</p>
                <ul className="table-item fs-base">
                  <li>
                    <p className="month">12</p>
                    <p>대한민국 소프트대전, 소프트웨이브2024 참가</p>
                  </li>
                  <li>
                    <p className="month">&ensp;</p>
                    <p>한국중소기업발전협회 R&D기획 공동개발 협약</p>
                  </li>
                  <li>
                    <p className="month">10</p>
                    <p>본사 사무실 이전 (서울 구로)</p>
                  </li>
                  <li>
                    <p className="month">&ensp;</p>
                    <p>울산 사무소 설립</p>
                  </li>
                  <li>
                    <p className="month">08</p>
                    <p>bizkok Platform 기술 투자</p>
                  </li>
                  <li>
                    <p className="month">07</p>
                    <p>메디지교육센터 업무 협약</p>
                  </li>
                  <li>
                    <p className="month">04</p>
                    <p>베트남 THL ONE 웹 전환 사업 업무협약 (MOU)</p>
                  </li>
                  <li>
                    <p className="month">&ensp;</p>
                    <p>한국중소기업발전협회 마케팅 협약</p>
                  </li>
                  <li>
                    <p className="month">03</p>
                    <p>MNK 코퍼레이션 생산관리시스템 구축</p>
                  </li>
                  <li>
                    <p className="month">01</p>
                    <p>안산 그린컴퓨터 아카데미 산학협력 협약</p>
                  </li>
                </ul>
              </div>
              <div className="table-year">
                <p className="fs-lg table-year-dot">2023</p>
                <ul className="table-item fs-base">
                  <li>
                    <p className="month">12</p>
                    <p>대한민국 소프트대전, 소프트웨이브2023 참가</p>
                  </li>
                  <li>
                    <p className="month">10</p>
                    <p>
                      <strong>SW프로세스인증(SP인증) 취득</strong>
                    </p>
                  </li>
                  <li>
                    <p className="month">07</p>
                    <p>소방산업공제조합 공제시스템 고도화 구축</p>
                  </li>
                  <li>
                    <p className="month">06</p>
                    <p>DB하이텍 YourFABs 고도화</p>
                  </li>
                  <li>
                    <p className="month">03</p>
                    <p>세아네트웍스 전자구매시스템 구축</p>
                  </li>
                </ul>
              </div>
              <div className="table-year">
                <p className="fs-lg table-year-dot">2022</p>
                <ul className="table-item fs-base">
                  <li>
                    <p className="month">11</p>
                    <p>한국석유공사 감사업무 및 업무자원시스템 고도화</p>
                  </li>
                  <li>
                    <p className="month">08</p>
                    <p>나이스평가정보 Info-Box 고도화</p>
                  </li>
                  <li>
                    <p className="month">05</p>
                    <p>컬럼비아스포츠웨어코리아 WebPOS 고도화 구축</p>
                  </li>
                  <li>
                    <p className="month">04</p>
                    <p>동원홈푸드 급식관리 시스템 구축</p>
                  </li>
                </ul>
              </div>
              <div className="table-year">
                <p className="fs-lg table-year-dot">2021</p>
                <ul className="table-item fs-base">
                  <li>
                    <p className="month">11</p>
                    <p>NH 생명 수련원통합관리시스템 고도화</p>
                  </li>
                  <li>
                    <p className="month">08</p>
                    <p>한국건설생활환경시험연구원 평가 관리시스템 구축</p>
                  </li>
                  <li>
                    <p className="month">05</p>
                    <p>자산관리공사 채권관리시스템 구축</p>
                  </li>
                  <li>
                    <p className="month">04</p>
                    <p>
                      <strong>No-Code 기반의 소스 생성기 런칭</strong>
                    </p>
                  </li>
                  <li>
                    <p className="month">01</p>
                    <p>항공안전기술원 드론관리시스템 UXBooster 도입</p>
                  </li>
                </ul>
              </div>
              <div className="table-year">
                <p className="fs-lg table-year-dot">2020</p>
                <ul className="table-item fs-base">
                  <li>
                    <p className="month">12</p>
                    <p>지역정보개발원 차세대 표준지방인사정보 시스템 구축</p>
                  </li>
                  <li>
                    <p className="month">11</p>
                    <p>
                      <strong>연구전담부서 인증</strong>
                    </p>
                  </li>
                  <li>
                    <p className="month">05</p>
                    <p>
                      <strong>대시보드 시스템 런칭</strong>
                    </p>
                  </li>
                  <li>
                    <p className="month">&ensp;</p>
                    <p>본사 사무실 이전 (서울 구로)</p>
                  </li>
                </ul>
              </div>
              <div className="table-year">
                <p className="fs-lg table-year-dot">2019</p>
                <ul className="table-item fs-base">
                  <li>
                    <p className="month">12</p>
                    <p>
                      <strong>앱 어워드 최우수상 수상 (한국타이어 스마트가이드 APP)</strong>
                    </p>
                  </li>
                  <li>
                    <p className="month">11</p>
                    <p>세아특수강 전자구매 시스템 구축</p>
                  </li>
                  <li>
                    <p className="month">06</p>
                    <p>한국타이어 스마트 가이드 구축</p>
                  </li>
                  <li>
                    <p className="month">04</p>
                    <p>도레이첨단소재 모바일 표준 수립</p>
                  </li>
                </ul>
              </div>
              <div className="table-year">
                <p className="fs-lg table-year-dot">2018</p>
                <ul className="table-item fs-base">
                  <li>
                    <p className="month">09</p>
                    <p>세아 창원 특수강 E-Business 시스템 구축</p>
                  </li>
                  <li>
                    <p className="month">07</p>
                    <p>
                      <strong>UXBooster 런칭</strong>
                    </p>
                  </li>
                  <li>
                    <p className="month">06</p>
                    <p>벤처기업 인증</p>
                  </li>
                  <li>
                    <p className="month">04</p>
                    <p>한익익스프레스 대스보드 시스템 구축</p>
                  </li>
                </ul>
              </div>
              <div className="table-year">
                <p className="fs-lg table-year-dot">2017</p>
                <ul className="table-item fs-base">
                  <li>
                    <p className="month">12</p>
                    <p>주식회사 테이크 설립</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="intro-organ">
        <div className="intro-organ-container m-auto">
          <div
            className="center-title"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-once="true"
          >
            <div className="line-hor"></div>
            <p className="fs-base fw-bold color-primary">ORGANIZATION</p>
            <h2 className="fw-bold mt-4 text-center">
              분야별 전문 인력이<br className="pc-none"></br> 체계적인 협업으로
              <br />
              최고의 성과를 만들어갑니다.
            </h2>
          </div>
          <div
            className="intro-organ-img"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="200"
          >
            <img src="./images/img-intro-organ.svg" alt="조직도" />
            <img src="./images/img-intro-organ-mo.svg" alt="조직도" />
          </div>
        </div>
      </section>

      <section id="intro-direction">
        <div className="m-auto intro-direction-container">
          <div
            className="left-title"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-once="true"
          >
            <div className="line-hor"></div>
            <p className="fs-base fw-bold color-primary">DIRECTION</p>
            <h2 className="fw-bold">오시는 길</h2>
          </div>
          <div
            className="intro-direction-box"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="200"
          >
            <div className="map">
              <img src="./images/img-intro-direction.svg" alt="오시는길" />
              <div className="map-btn">
                <a href="https://naver.me/F74kwepo" target="_blank" className="map-link-btn">
                  네이버지도
                </a>
                <a href="https://kko.kakao.com/qercIh3w-V" target="_blank" className="map-link-btn">
                  카카오맵
                </a>
              </div>
            </div>
            <div className="map-text">
              <div className="address-text">
                <p className="address-head fs-base color-caption">주소</p>
                <p className="fs-base">
                  (08380) 서울특별시 구로구 디지털로33길 11, 1201호 (구로동, 에이스테크노타워 8차)
                </p>
              </div>
              <div className="address-text">
                <p className="address-head fs-base color-caption">연락처</p>
                <p className="fs-base">02-855-0801 / FAX : 02-855-0802</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Intro;
